import script from "./ConfigurationSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationSidebar.vue?vue&type=style&index=0&id=48c3ffe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c3ffe8"]])

export default __exports__